import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
})
export class AdminDashboardComponent implements OnInit {
  public showMenu: any = false;
  public showSideMenu: any = true;
  public userLogged;
  dataTable: any;
  dtOptions: DataTables.Settings = {};
  @ViewChild('dataTable', { static: true }) table;

  constructor(private router: Router, private SessionService: SessionService) {}

  showMenuFn() {
    this.showMenu = !this.showMenu;
  }
  showSideMenuFn() {
    this.showSideMenu = !this.showSideMenu;
  }
  Logout() {
    this.SessionService.logout();
    this.router.navigate(['/']);
  }

  ngOnInit(): void {
    this.userLogged = this.SessionService.loggedInUser();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      processing: true,
    };
  }
}
